function footerAccordion() {
  if (window.matchMedia('(min-width: 750px)').matches) {
    return
  }
  const handleCollapse = (heading) => {
    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed')
      heading.setAttribute('aria-expanded', 'true')
    } else {
      heading.classList.add('block-collapsed')
      heading.setAttribute('aria-expanded', 'false')
    }
  }
  document.querySelectorAll('.grid .footer-block__heading').forEach((heading, index) => {
    const panel = heading.nextElementSibling
    if (!panel) return

    heading.classList.add('block-collapsed')
    heading.setAttribute('role', 'button')
    heading.setAttribute('aria-expanded', 'false')
    heading.setAttribute('tabindex', '0')

    if (!panel.id) {
      panel.setAttribute('id', `footer-block-index-${index}`)
    }
    heading.setAttribute('aria-controls', panel.id)

    heading.addEventListener('click', () => { handleCollapse(heading) })
    heading.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        handleCollapse(heading)
      }
    })
  })
}

window.addEventListener('DOMContentLoaded', (event) => {
  window.dispatchEvent(new Event('resize'));
  footerAccordion()
});

document.addEventListener("shopify:section:load", function(event) {
  window.dispatchEvent(new Event('resize'));
  footerAccordion()
});